import React from "react";
import './services.css';
import { BiCheck } from "react-icons/bi";

const Services = () => {
    return(
        <section id="services">
            <h5>What I Offer</h5>
            <h2>Services</h2>

            <div className="container service__container">
                <article className="service">
                    <div className="service__head">
                        <h3>Frontend</h3>
                    </div>

                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                    </ul>
                </article>
                {/* END OF FRONT END */}

                <article className="service">
                    <div className="service__head">
                        <h3>Backend</h3>
                    </div>

                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                    </ul>
                </article>
                {/* END OF BACK END */}

                <article className="service">
                    <div className="service__head">
                        <h3>DEVOPS</h3>
                    </div>

                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon"/>
                            <p>Responsive</p>
                        </li>
                    </ul>
                </article>
                {/* END OF DEVOPS */}
            </div>
        </section>
    )
}

export default Services